import * as React from 'react';
import * as queryString from 'query-string';
import config from '../../config/config';
import shareConfig from '../../config/share.config';
import server from '../../server/apiServer';
import HeaderComp from '../../components/common/header';
import TitleComp from '../../components/common/title';
import LoadingMoreComp from '../../components/common/loading-more';
import FooterComp from '../../components/common/footer';
import ToTopComp from '../../components/common/toTop';
import ItemComp from '../../components/main/item';

interface IProps extends React.Props<any> {
    location: any;
    match: any;
}

class ListComp extends React.Component<IProps, any> {
    public state = {
        labelName:  '',
        labelNum: this.props.match.params.id,
        list: [],
        page: 1,
        isLoading: false, // 是否加载中...
        loadedOver: false, // 是否加载完成
    };
    public componentDidMount() {
        window.scrollTo(0, 0);
        const name = `${queryString.parse(this.props.location.search).name}`;
        (window as any)._hmt.push(['_trackPageview', `/listPage/${this.state.labelNum}?name=${name}`]);
        this.setState({ labelName: name});
        this.setShareInfo(name);
        // 获取数据
        this.getList();
    }
    public componentWillReceiveProps(props: IProps) {
        if(this.state.labelNum === props.match.params.id) {
            return;
        }
        const name = `${queryString.parse(props.location.search).name}`;
        this.setState({
            labelName: name,
            labelNum: props.match.params.id,
            page: 1,
            list: [],
            isLoading: false,
            loadedOver: false
        }, () => {
            this.setShareInfo(name);
            this.getList();
        });
    }
    public render() {
        const state = this.state;
        return (
            <div>
                <HeaderComp parentProps={this.props}/>
                <TitleComp text={state.labelName} />
                <div className="main-list list-container">
                    <ul>
                        {
                            state.list.map((v: any, k: number) => {
                                return (
                                    <ItemComp key={`main-item${k}`} data={v}/>
                                );
                            })
                        }
                    </ul>
                    {
                        state.list.length === 0 && state.loadedOver ? <p className="message-tips">暂无更多数据</p> : null
                    }
                </div>
                {
                    !state.loadedOver ? <LoadingMoreComp isLoading={state.isLoading} loadMoreAction={() => this.loadMoreActoin()}/> : null
                }
                <FooterComp />
                <ToTopComp />
            </div>
        );
    }
    // 加载更多数据
    private loadMoreActoin() {
        if(this.state.isLoading) {
            return;
        }
        this.setState({isLoading: true});
        this.state.page ++;
        this.getList();
    }

    /**
     * 
     * @param titleStr 分享标题
     */
    private setShareInfo(titleStr: string) {
        const xhrData = `jsApiDomain=&url=${encodeURIComponent(window.location.href.split('#')[0])}`;
        (window as any).WeChatShare({
            callback() {
                const shareInfo = shareConfig.list;
                const [title, desc, imgUrl, link] = [
                   `${titleStr}-慧乐居`,
                    shareInfo.desc,
                    shareInfo.imgUrl,
                    shareInfo.link()
                ];
                (window as any).wx.onMenuShareAppMessage({
                    desc,
                    imgUrl,
                    link,
                    title
                });
                (window as any).wx.onMenuShareTimeline({
                  desc,
                  imgUrl,
                  link,
                  title
                });
            },
            data: xhrData,
            url: config.WAPAPI
        });
    }
    // 获取数据
    private async getList() {
        const r = await server.get('wap/list/articleList', {
            labelNum: this.state.labelNum,
            pageSize: 10,
            pageNum: this.state.page
        });
        if(r.code === 1) {
            this.setState({
                list: [...this.state.list, ...r.obj.list],
                isLoading: false,
                loadedOver: r.obj.pages <= this.state.page ? true : false
            });
        }
    }
}

export default ListComp;


// WEBPACK FOOTER //
// ./src/containers/list/index.tsx